module.exports = __webpack_public_path__ + "static/media/vitoria.d97cf27f.jpg";